import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconScissors24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconScissors24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M21.75 6.442a.75.75 0 0 1-.257 1.029l-12.68 7.608a3.448 3.448 0 1 1-.83-1.252L11.03 12l-3.046-1.828a3.448 3.448 0 1 1 .83-1.252l3.674 2.205 8.235-4.94a.75.75 0 0 1 1.029.257M5.59 18.258a1.948 1.948 0 1 1 0-3.896 1.948 1.948 0 0 1 0 3.896m0-8.62a1.948 1.948 0 1 1 0-3.897 1.948 1.948 0 0 1 0 3.897m8.817 4.389 1.46-.874 5.626 3.376a.75.75 0 0 1-.772 1.286z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconScissors24);
